import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { roadmapProgress } from "../lib/api";
import { useAuth } from "./useAuth";
import { MarketplaceUnlockModal } from "../components/MarketplaceUnlockModal";

const Ctx = createContext(null);
export const useMarketplaceUnlock = () => useContext(Ctx);

export const MarketplaceUnlockProvider = ({ children }) => {
  const { user } = useAuth();
  const [pct, setPct] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  const refresh = useCallback(() => {
    roadmapProgress()
      .then((d) => setPct(d?.pct ?? 0))
      .catch(() => setPct(0))
      .finally(() => setLoaded(true));
  }, []);
  useEffect(() => { refresh(); }, [refresh, user]);

  const unlocked = pct >= 100;

  // Runs `proceed` if unlocked; otherwise shows the unlock modal. Returns true when allowed.
  const guard = useCallback((proceed) => {
    if (unlocked) { if (proceed) proceed(); return true; }
    setOpen(true);
    return false;
  }, [unlocked]);

  return (
    <Ctx.Provider value={{ unlocked, pct, loaded, guard, openModal: () => setOpen(true), refresh }}>
      {children}
      <MarketplaceUnlockModal open={open} onClose={() => setOpen(false)} pct={pct} />
    </Ctx.Provider>
  );
};
